module.exports = __webpack_public_path__ + "static/media/1011078.63029045.jpg";